<template>
    <div
        :class="{ pointer: !disabled }"
        @dragover.prevent="dragoverTarget"
        @drop.prevent="drop"
        @click.stop="clicked"
    >
        <input
            type="file"
            hidden
            @change="onChange"
            ref="fileInput"
            :accept="allowedExtensions"
        />

        <div
            v-if="showUploader"
            class="border rounded-lg border-dashed pa-2"
            :class="{ 'border-success': overTarget }"
            style="min-height: 50px"
        >
            <div class="text-center">
                <v-icon>mdi-download-outline</v-icon>
                <br />
                Drop a file here, or click to browse...
            </div>
        </div>

        <div v-if="!showUploader">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "FileDragAndDrop",

    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        dragging: {
            type: Boolean,
            required: true,
        },
        showUploader: {
            type: Boolean,
            required: true,
        },
        allowedExtensions: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            overTarget: false,

            /**
             * Wait until the drag over the window has stopped, then reset
             */
            dragCatcher: _.debounce(function () {
                this.draggingComputed = false;
            }, 150),

            /**
             * Wait until the drag is not over the target, then reset
             */
            overTargetCatcher: _.debounce(function () {
                this.overTarget = false;
            }, 100),

            /**
             * When a file is dragged over the window
             */
            dragOverWindow: _.throttle((e) => {
                if (this.disabled) {
                    return;
                }
                e.preventDefault();
                this.draggingComputed = true;
                this.dragCatcher();
            }, 100),
        };
    },

    mounted() {
        /**
         * Listen for a drag over the main window
         */
        window.addEventListener("dragover", this.dragOverWindow);
    },

    beforeDestroy() {
        window.removeEventListener("dragover", this.dragOverWindow);
    },

    methods: {
        /**
         * Show the browse window
         */
        clicked() {
            if (this.disabled) return;
            this.$refs.fileInput.click();
        },

        /**
         * When a new file is chosen, emit it!
         */
        onChange() {
            this.$emit("change", this.$refs.fileInput.files[0]);
        },

        /**
         * Listen for a drag over the target
         */
        dragoverTarget: _.throttle(function () {
            this.overTarget = true;
            this.overTargetCatcher();
        }, 50),

        /**
         * Listen for a file to be dropped
         */
        drop(e) {
            if (this.disabled) {
                return;
            }

            this.$refs.fileInput.files = e.dataTransfer.files;

            this.onChange();
        },

        reset() {
            this.$refs.fileInput.value = "";
        },
    },

    computed: {
        /**
         * return if we should show the upload box
         * @returns {boolean}
         */
        draggingComputed: {
            get() {
                return this.dragging;
            },
            set(value) {
                this.$emit("update:dragging", value);
            },
        },
    },
};
</script>

<style scoped>
.pointer {
    cursor: pointer;
}

.border.border-dashed {
    border-width: 3px !important;
    border-style: dashed !important;
    border-color: rgba(0, 0, 0, 0.12);
}

.theme--dark .border.border-dashed {
    border-color: rgba(255, 255, 255, 0.24);
}
</style>
